import { useState } from 'react';

export function useCadernoPieces() {
  const [savedPieces, setSavedPieces] = useState([]);
  const [activePieceId, setActivePieceId] = useState(null);

  return {
    savedPieces, setSavedPieces,
    activePieceId, setActivePieceId,
  };
}
